import { useState, type FormEvent } from "react";
import { api } from "../api";

interface Props { requireCurrent: boolean; onSuccess: () => void; }

export function ChangePasswordScreen({ requireCurrent, onSuccess }: Props) {
  const [current, setCurrent] = useState("");
  const [newPw, setNewPw] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.changePassword(requireCurrent ? current : undefined, newPw);
      onSuccess();
    } catch (e: any) {
      setError(e.message || "Erro");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form onSubmit={submit} style={{ maxWidth: 360, margin: "80px auto", padding: 32, background: "var(--sf)", border: ".5px solid var(--bd)", borderRadius: 14, fontFamily: "'DM Sans',sans-serif" }}>
      <h1 style={{ fontSize: 18, marginBottom: 6 }}>{requireCurrent ? "Alterar senha" : "Defina uma nova senha"}</h1>
      <p style={{ fontSize: 13, color: "var(--tx2)", marginBottom: 20 }}>
        {requireCurrent ? "Informe a senha atual e a nova senha." : "Sua senha é temporária. Escolha uma nova senha com pelo menos 10 caracteres."}
      </p>
      {requireCurrent && (
        <div className="fr">
          <label htmlFor="cpCur">Senha atual</label>
          <input id="cpCur" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} />
        </div>
      )}
      <div className="fr">
        <label htmlFor="cpNew">Nova senha</label>
        <input id="cpNew" type="password" autoComplete="new-password" value={newPw} onChange={(e) => setNewPw(e.target.value)} />
      </div>
      <div style={{ color: "#A32D2D", fontSize: 12, marginBottom: 8, minHeight: 16 }}>{error}</div>
      <button type="submit" className="btn-save" style={{ width: "100%" }} disabled={submitting}>Salvar e continuar</button>
    </form>
  );
}
